if (!customElements.get('approval-compare-item-alternative')) {
    class ApprovalCompareItemAlternative extends HTMLElement {

        constructor() {
            super();

            this.quantityInput = null;
            this.isMain = this.dataset.main == "true";
            this.variantId = parseInt(this.dataset.variantId);
            this.price = parseInt(this.dataset.price);
            this.depositReference = this.dataset.depositReference ? parseInt(this.dataset.depositReference) : '';
            this.identifier = this.dataset.identifier;
            this._disabled = false;

            this.parent = this.closest('approval-compare-item');

            this.key = this.dataset.key || null;
            this.quantity = parseInt(this.dataset.quantity);
            this.handle = this.dataset.handle;

        }

        get disabled() {
            return this._disabled;
        }

        set disabled(value) {
            if (value == this._disabled) return;
            this._disabled = value;
            this.quantityInput.input.disabled = value;
            this.quantityInput.input.setAttribute('aria-disabled', `${value}`);
            this.quantityInput.querySelectorAll('button').forEach((button) => {
                button.disabled = value;
                button.setAttribute('aria-disabled', `${value}`);
            });
        }

        connectedCallback() {
            this.quantityInput = this.querySelector('quantity-input');
            this.quantityInput.addEventListener('click', this.handleClick.bind(this));
            /**
             * Dirty fix
             */
            setTimeout(() => {
                this.quantityInput.input.addEventListener('change', this.handleChange.bind(this));
            }, 200);
        }

        disconnectedCallback() {
            this.quantityInput.removeEventListener('click', this.handleClick.bind(this));
            this.quantityInput.input.removeEventListener('change', this.handleChange.bind(this));
        }

        async handleClick(evt) {

            if (!evt.target.matches('.qty-input__btn')) return;

            this.disabled = true;

            evt.preventDefault();

            if (evt.target.name === 'plus') {
                this.quantityInput.input.stepUp();
            } else {
                this.quantityInput.input.stepDown();
            }

            this.handleChange();
        }

        async handleChange() {

            this.disabled = true;

            if (this.quantityInput.quantity < 0) {
                this.quantityInput.quantity = 0;
            }

            if (this.isMain && this.quantityInput.quantity > parseInt(this.parent.item.properties['_available'])) {
                this.quantityInput.quantity = parseInt(this.parent.item.properties['_available']);
            }

            if (this.quantityInput.quantity > 0) {
                this.quantityInput.classList.add('in-cart');
            } else if (!this.isMain) {
                this.quantityInput.classList.remove('in-cart');
            }

            await this.parent.handleAlternativeChange({
                variantId: this.variantId,
                quantity: this.quantityInput.quantity,
                price: this.price,
                identifier: this.identifier,
                depositReference: this.depositReference,
                main: this.isMain,
                key: this.key,
                handle: this.handle,
                origin: this
            });

            this.inCart = this.quantityInput.quantity > 0;

            this.disabled = false;
        }

        debounce(fn, wait = 300) {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
            };
        }
    }

    customElements.define('approval-compare-item-alternative', ApprovalCompareItemAlternative);
}

